import Home from './Screen/home';

function App() {
  return (
    <>
      <Home/>
    </>
    
  );
}

export default App;
